/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.9964 11.1757A.7606.7606 0 0 1 6 11.25v12a.75.75 0 0 1-1.5 0v-12a.7606.7606 0 0 1 .0036-.0743C2.7901 10.8297 1.5 9.3155 1.5 7.5s1.2901-3.3297 3.0036-3.6757A.7598.7598 0 0 1 4.5 3.75v-3a.75.75 0 0 1 1.5 0v3a.7598.7598 0 0 1-.0036.0743C7.7099 4.1703 9 5.6845 9 7.5s-1.2901 3.3297-3.0036 3.6757ZM19.5 23.25a.75.75 0 0 1-1.5 0v-3a.7607.7607 0 0 1 .0036-.0743C16.2901 19.8297 15 18.3155 15 16.5s1.2901-3.3297 3.0036-3.6757A.7607.7607 0 0 1 18 12.75v-12a.75.75 0 0 1 1.5 0v12a.7607.7607 0 0 1-.0036.0743c1.7135.346 3.0036 1.8602 3.0036 3.6757s-1.2901 3.3297-3.0036 3.6757a.7607.7607 0 0 1 .0036.0743v3ZM21 16.5c0 1.2426-1.0074 2.25-2.25 2.25s-2.25-1.0074-2.25-2.25 1.0074-2.25 2.25-2.25S21 15.2574 21 16.5Zm-13.5-9c0-1.2426-1.0074-2.25-2.25-2.25S3 6.2574 3 7.5s1.0074 2.25 2.25 2.25S7.5 8.7426 7.5 7.5Z"
    clipRule="evenodd"
  />,
  'Configure'
);
